import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./StreakToast.module.css";
import { useGame } from "../store/game";

/** Shows once per session if the server awarded a daily login bonus. */
export function StreakToast() {
  const streakBonus = useGame((s) => s.streakBonus);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (streakBonus > 0) {
      setVisible(true);
      const t = setTimeout(() => setVisible(false), 3_000);
      return () => clearTimeout(t);
    }
  }, [streakBonus]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={styles.toast}
          initial={{ y: -20, opacity: 0, scale: 0.92 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: -16, opacity: 0, scale: 0.94 }}
          transition={{ type: "spring", stiffness: 300, damping: 28 }}
        >
          🗓 Щоденний бонус
          <span className={styles.gt}>+{streakBonus} GT</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
